module.exports = __webpack_public_path__ + "img/farzana-christopher-102.d57e64d3.jpg";